import { createAsyncThunk } from "@reduxjs/toolkit";
import { IAdmissionCertificate } from "src/services/student/student.model";
import studentService from "src/services/student/student.service";

export const searchStudentData = createAsyncThunk(
  "student/searchStudentData",
  async () => {
    return studentService.searchStudentData();
  }
);

export const getStudentAdmissionDetailsById = createAsyncThunk(
  "student/getStudentAdmissionDetailsById",
  async (id: number) => {
    return studentService.getStudentAdmissionDetailsById(id);
  }
);

export const createCertificate = createAsyncThunk(
  "admission/createCertificate",
  async (data: IAdmissionCertificate | {}) => {
    return studentService.createCertificate(data);
  }
);
